export let getWidgetTranslation;

export function setWidget(widget) {
    getWidgetTranslation = widget.getWidgetTranslation;
}
